export const errors = {
  CANNOT_BE_EMPTY: 'VALIDATION.CANNOT_BE_EMPTY',
  INCORRECT_LENGTH: 'VALIDATION.INCORRECT_LENGTH',
  MUST_BE_CHECKED: 'VALIDATION.MUST_BE_CHECKED',
};
